import React from 'react';
import FormButton from '../../style/styledComponents/FormButton';

import { FaCheckCircle, FaTimesCircle, FaThumbsUp } from 'react-icons/fa';

const ErroMsgValidacao = ({ close, dataValidationCpf }) => {
	const errorCode = dataValidationCpf.cod;
	let text = '';
	let showButton = false;
	let showButtonContinue = false;
	switch (errorCode) {
		case 1:
			showButtonContinue = true;
			text = (
				<p>
					Ops, identificamos que já tem um boleto para essa assinatura nesse
					CPF. Gostaria de continuar mesmo assim? Caso prefira, ligue para{' '}
					<font color='#1a62f4'> 4000-1664</font> para tirar dúvidas.
				</p>
			);
			break;
		case 2:
			text = (
				<p>
					Ops, identificamos que esse CPF já está com essa assinatura em
					processamento. Aguarde o término do cadastro para ficar ativo ou ligue
					para <font color='#1a62f4'> 4000-1664</font> para qualquer dúvida.
				</p>
			);
			break;
		default:
			showButton = true;
			text = (
				<p>
					Você já tem essa assinatura ativa. Acompanhe tudo sobre ela no{' '}
					<a href='https://meu.yalo.com.br/bemvindo'>Meu Yalo</a>. Quer assinar
					para outra pessoa?
				</p>
			);
	}
	return (
		<div className='overlay'>
			<div className='overlay-box'>
				<div className='overlay-box--content'>{text}</div>
				{showButton ? (
					<FormButton className='overlay-button'>
						<button
							className='overlay-box--close f-bold btn-border-color-yes'
							onClick={() => close()}>
							<FaCheckCircle size={20} /> Sim
						</button>

						<button
							className='overlay-box--close f-bold btn-border-color-not'
							onClick={() => {
								window.location = 'https://meu.yalo.com.br/bemvindo';
							}}>
							<FaTimesCircle size={20} /> {' 	'} Não
						</button>
					</FormButton>
				) : showButtonContinue ? (
					<FormButton className='overlay-button'>
						<button
							className='overlay-box--close f-bold btn-border-color-continue'
							onClick={() => close()}>
							<FaCheckCircle size={18} /> Continuar
						</button>
					</FormButton>
				) : (
					<FormButton className='overlay-button'>
						<button
							className='overlay-box--close f-bold btn-border-color-ok'
							onClick={() => close()}>
							<FaThumbsUp size={18} /> Ok
						</button>
					</FormButton>
				)}
			</div>
		</div>
	);
};

export default ErroMsgValidacao;
